import { Roles } from './../model/roles.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class RolesService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(): Observable<any> {
        return this.get<any>(EndPoints.roles_Index).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    createRole(newRole: Roles): Observable<any> {
        return this.post<any>(EndPoints.roles_Create, false, '', {
            newRole: newRole
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    updateRole(editRole: Roles): Observable<any> {
        return this.post<any>(EndPoints.roles_Update, false, '', {
            editRole: editRole
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteRole(deleteRole: Roles): Observable<any> {
        return this.post<any>(EndPoints.roles_Delete, false, '', {
            deleteRole: deleteRole
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
